import React from 'react'
import { TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ApolloError } from '@apollo/client'
import { isEmpty } from 'lodash'
import moment from 'moment'
import EmptyCells from '../../../../../components/EmptyCells'
import DefaultTableCell from '../../../../../components/DefaultTableCell'
import {
  NestedColoredTableRow,
  NestedDefaultTableRow,
  DefaultTableCellToNested,
  ContainerStyledTable
} from '../../../../../components/ColoredTableRow'
import {
  formatNumber,
  getDaysInMonth,
  DaysInMonth
} from '../../../../../utils/Helpers'
import { AGG_STATUS_CHECKOUT } from '../../../../../types/Order'
import { FilterDailyMonitoringDetails } from '../../../../../types/FilterDailyMonitoringDetails'

const useStyles = makeStyles({
  text: {
    textAlign: 'center',
    padding: 0
  }
})

type Props = {
  loading: boolean
  data: any
  error: ApolloError | undefined
  filters: FilterDailyMonitoringDetails
}

const title = 'QTD Pedidos (Em aberto)'
export default function DailyOrderOpenGMVQuantity ({ loading, error, filters, data }: Props): JSX.Element {
  const classes = useStyles()
  if (loading || !data?.ordersAggs?.aggregations?.salesOverTime) return <EmptyCells title={title} />
  if (error) return <EmptyCells title={title} />

  const { buckets } = data?.ordersAggs?.aggregations?.salesOverTime

  return (
    <TableRow>
      <DefaultTableCellToNested>
        {title}
        <ContainerStyledTable>
          <NestedDefaultTableRow>Total: </NestedDefaultTableRow>
          <NestedDefaultTableRow>Dentro do prazo: </NestedDefaultTableRow>
          <NestedDefaultTableRow>Fora do prazo: </NestedDefaultTableRow>
        </ContainerStyledTable>
      </DefaultTableCellToNested>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = buckets.filter((b: any) => {
          return moment
            .parseZone(String(b.key_as_string))
            .isSame(moment(day.date, 'DD/MMM/YYYY'), 'day')
        })[0]
        return !isEmpty(bucket)
          ? (
          <DefaultTableCell key={bucket.key_as_string} className={classes.text}>
            <NestedColoredTableRow className="blue">
              {formatNumber(bucket[AGG_STATUS_CHECKOUT]?.doc_count, 0)}
            </NestedColoredTableRow>
            <NestedColoredTableRow className="green">
              {formatNumber(bucket[AGG_STATUS_CHECKOUT]?.inSla?.doc_count, 0)}
            </NestedColoredTableRow>
            <NestedColoredTableRow className="red">
              {formatNumber(bucket[AGG_STATUS_CHECKOUT]?.outSla?.doc_count, 0)}
            </NestedColoredTableRow>
          </DefaultTableCell>
            )
          : (
          <DefaultTableCell>-</DefaultTableCell>
            )
      })}
    </TableRow>
  )
}
